import React from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import {
  LancamentosTotalGeral,
  LancamentosTotalGeralItem,
  LancamentosTotalGeralDivider,
  Totais,
  Total,
  TabelaTotalGeral,
} from './styles';

function GrandTotal({ data }) {
  if (!data.lancamentosGeraisCredito && !data.lancamentosGeraisDebito) {
    return null;
  }

  const creditLancamentos = data.lancamentosGeraisCredito || [];
  const debitLancamentos = data.lancamentosGeraisDebito || [];
  const atosCooperativosGerais = data.atosCooperativosGerais || [];

  return (
    <div style={{ pageBreakBefore: 'always' }}>
      <h2 className="center-align">
        <b>Total Geral {data.folha}</b>
      </h2>
      <LancamentosTotalGeral>
        <LancamentosTotalGeralItem>
          <h4 className="center-align">
            <b>Créditos</b>
          </h4>
          <table width="100%">
            <tbody>
              {creditLancamentos.map((lancamento) => (
                <tr key={lancamento.codigo}>
                  <td>{lancamento.codigo}</td>
                  <td>{lancamento.descricao}</td>
                  <td>{moneyFormat(lancamento.quantidade)}</td>
                  <td className="right-align">{moneyFormat(lancamento.valor)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </LancamentosTotalGeralItem>
        <LancamentosTotalGeralDivider>&nbsp;</LancamentosTotalGeralDivider>
        <LancamentosTotalGeralItem>
          <h4 className="center-align">
            <b>Débitos</b>
          </h4>
          <table width="100%">
            <tbody>
              {debitLancamentos.map((lancamento) => (
                <tr key={lancamento.codigo}>
                  <td>{lancamento.codigo}</td>
                  <td>{lancamento.descricao}</td>
                  <td>{moneyFormat(lancamento.quantidade)}</td>
                  <td className="right-align">{moneyFormat(lancamento.valor)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </LancamentosTotalGeralItem>
      </LancamentosTotalGeral>
      <Totais>
        <Total>
          <b>Total de Vencimento:</b> {moneyFormat(data.totalVencimento)}
        </Total>
        <Total>
          <b>Total de Desconto:</b> {moneyFormat(data.totalDesconto)}
        </Total>
        <Total>
          <b>Total de Cooperados:</b> {data.totalCooperados}
        </Total>
        <Total>
          <b>Total Líquido dos Centros de Custo:</b> {moneyFormat(data.totalLiquido)}
        </Total>
      </Totais>
      {atosCooperativosGerais.length > 0 && (
        <TabelaTotalGeral style={{ marginLeft: 20 }}>
          <tbody>
            {atosCooperativosGerais.map((ato) => (
              <tr key={ato.codigo}>
                <td>{ato.codigo}</td>
                <td>{ato.descricao}</td>
                <td>{moneyFormat(ato.valor)}</td>
              </tr>
            ))}
          </tbody>
        </TabelaTotalGeral>
      )}
    </div>
  );
}

GrandTotal.propTypes = {
  data: PropTypes.shape({
    folha: PropTypes.string,
    totalVencimento: PropTypes.number,
    totalDesconto: PropTypes.number,
    totalCooperados: PropTypes.number,
    totalLiquido: PropTypes.number,
    lancamentosGeraisCredito: PropTypes.arrayOf(
      PropTypes.shape({
        codigo: PropTypes.string,
        descricao: PropTypes.string,
        quantidade: PropTypes.number,
        valor: PropTypes.number,
      })
    ),
    lancamentosGeraisDebito: PropTypes.arrayOf(
      PropTypes.shape({
        codigo: PropTypes.string,
        descricao: PropTypes.string,
        quantidade: PropTypes.number,
        valor: PropTypes.number,
      })
    ),
    atosCooperativosGerais: PropTypes.arrayOf(
      PropTypes.shape({
        codigo: PropTypes.string,
        descricao: PropTypes.string,
        valor: PropTypes.number,
      })
    ),
  }).isRequired,
};

export default GrandTotal;
